import React from "react";


export const NotificationTrueIcon = (props) => {

    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fill="#FE8E38"
          d="M21 6.5c0 1.93-1.57 3.5-3.5 3.5S14 8.43 14 6.5 15.57 3 17.5 3 21 4.57 21 6.5zm-2 5.29c-.5.13-1 .21-1.5.21A5.51 5.51 0 0112 6.5c0-1.47.58-2.8 1.5-3.79A1.93 1.93 0 0012 2c-1.1 0-2 .9-2 2v.29C7.03 5.17 5 7.9 5 11v6l-2 2v1h18v-1l-2-2v-5.21zM12 23c1.11 0 2-.89 2-2h-4a2 2 0 002 2z"
        ></path>
      </svg>
    )
}
export const NotificationActive = (props) => {

    return (
        <>
            <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 4.5C18 6.43 16.43 8 14.5 8C12.57 8 11 6.43 11 4.5C11 2.57 12.57 1 14.5 1C16.43 1 18 2.57 18 4.5ZM16 9.79C15.5 9.92 15 10 14.5 10C13.0421 9.99736 11.6447 9.41705 10.6138 8.38617C9.58295 7.35529 9.00264 5.95788 9 4.5C9 3.03 9.58 1.7 10.5 0.710001C10.3185 0.487542 10.0897 0.308372 9.83021 0.185545C9.57072 0.0627193 9.28709 -0.000668319 9 1.43799e-06C7.9 1.43799e-06 7 0.900001 7 2V2.29C4.03 3.17 2 5.9 2 9V15L0 17V18H18V17L16 15V9.79ZM9 21C10.11 21 11 20.11 11 19H7C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21Z" fill="#FE8E38" />
                {/* <circle cx="14.5" cy="4.5" r="3.5" fill="#F40C0C" /> */}
            </svg>

        </>
    )
}
export const NoticationWhiteActive = (props) => {


  return (
      <>

          <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 4.5C18 6.43 16.43 8 14.5 8C12.57 8 11 6.43 11 4.5C11 2.57 12.57 1 14.5 1C16.43 1 18 2.57 18 4.5ZM16 9.79C15.5 9.92 15 10 14.5 10C13.0421 9.99736 11.6447 9.41705 10.6138 8.38617C9.58295 7.35529 9.00264 5.95788 9 4.5C9 3.03 9.58 1.7 10.5 0.710001C10.3185 0.487542 10.0897 0.308372 9.83021 0.185545C9.57072 0.0627193 9.28709 -0.000668319 9 1.43799e-06C7.9 1.43799e-06 7 0.900001 7 2V2.29C4.03 3.17 2 5.9 2 9V15L0 17V18H18V17L16 15V9.79ZM9 21C10.11 21 11 20.11 11 19H7C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21Z" fill="#F8FAF6" />
              <circle cx="14.5" cy="4.5" r="3.5" fill="#F40C0C" />
          </svg>


      </>
  )
}
export const NotificationIconWhite = (props) => {

  return (
      <>
          <svg width="18" height="21"  viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 4.50001C18 6.43001 16.43 8.00001 14.5 8.00001C12.57 8.00001 11 6.43001 11 4.50001C11 2.57001 12.57 1.00001 14.5 1.00001C16.43 1.00001 18 2.57001 18 4.50001ZM16 9.79001C15.5 9.92001 15 10 14.5 10C13.0421 9.99736 11.6447 9.41705 10.6138 8.38617C9.58295 7.3553 9.00264 5.95788 9 4.50001C9 3.03001 9.58 1.70001 10.5 0.710005C10.3185 0.487546 10.0897 0.308375 9.83021 0.185549C9.57072 0.0627231 9.28709 -0.000664505 9 5.25269e-06C7.9 5.25269e-06 7 0.900005 7 2.00001V2.29001C4.03 3.17001 2 5.90001 2 9.00001V15L0 17V18H18V17L16 15V9.79001ZM9 21C10.11 21 11 20.11 11 19H7C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21Z"  id="notification" fill="#FFF" />
          </svg>
      </>
  )
}
export const NotificationIcon = (props) => {

  return (
      <>
          <svg width="18" height="21"  viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 4.50001C18 6.43001 16.43 8.00001 14.5 8.00001C12.57 8.00001 11 6.43001 11 4.50001C11 2.57001 12.57 1.00001 14.5 1.00001C16.43 1.00001 18 2.57001 18 4.50001ZM16 9.79001C15.5 9.92001 15 10 14.5 10C13.0421 9.99736 11.6447 9.41705 10.6138 8.38617C9.58295 7.3553 9.00264 5.95788 9 4.50001C9 3.03001 9.58 1.70001 10.5 0.710005C10.3185 0.487546 10.0897 0.308375 9.83021 0.185549C9.57072 0.0627231 9.28709 -0.000664505 9 5.25269e-06C7.9 5.25269e-06 7 0.900005 7 2.00001V2.29001C4.03 3.17001 2 5.90001 2 9.00001V15L0 17V18H18V17L16 15V9.79001ZM9 21C10.11 21 11 20.11 11 19H7C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21Z"  id="notification" fill="#FE8E38" />
          </svg>
      </>
  )
}
export const CloseBlackIcon = (props) => {



  return (
      <>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.1639 16.3277C5.84749 16.6441 5.83242 17.2091 6.17143 17.5406C6.5029 17.872 7.06791 17.8645 7.38432 17.5481L11.9948 12.9301L16.6128 17.5481C16.9368 17.872 17.4943 17.872 17.8257 17.5406C18.1497 17.2016 18.1572 16.6516 17.8257 16.3277L13.2152 11.7097L17.8257 7.09916C18.1572 6.77522 18.1572 6.21775 17.8257 5.88627C17.4867 5.56233 16.9368 5.5548 16.6128 5.87874L11.9948 10.4968L7.38432 5.87874C7.06791 5.56233 6.49537 5.54727 6.17143 5.88627C5.83996 6.21775 5.84749 6.78276 6.1639 7.09916L10.7819 11.7097L6.1639 16.3277Z" fill="black" />
          </svg>

      </>
  )
}
export const PlusIcon = () => {
  return (
      <>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.54534 7.5625H6.14076V12.1579C6.14076 12.625 6.52497 13.0167 6.99958 13.0167C7.47419 13.0167 7.8584 12.625 7.8584 12.1579V7.5625H12.4538C12.9209 7.5625 13.3126 7.17829 13.3126 6.70368C13.3126 6.22907 12.9209 5.84487 12.4538 5.84487H7.8584V1.24944C7.8584 0.782366 7.47419 0.390625 6.99958 0.390625C6.52497 0.390625 6.14076 0.782366 6.14076 1.24944V5.84487H1.54534C1.07826 5.84487 0.686523 6.22907 0.686523 6.70368C0.686523 7.17829 1.07826 7.5625 1.54534 7.5625Z" fill="black" />
          </svg>

      </>
  )
}
export const DeleteIcon = () => {
  return (
      <>
          <svg  
          viewBox="0,0,256,256" width="24px" height="24px">
              <g fill="#d70707" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" ><g transform="scale(10.66667,10.66667)"><path d="M10,2l-1,1h-5v2h1v15c0,0.52222 0.19133,1.05461 0.56836,1.43164c0.37703,0.37703 0.90942,0.56836 1.43164,0.56836h10c0.52222,0 1.05461,-0.19133 1.43164,-0.56836c0.37703,-0.37703 0.56836,-0.90942 0.56836,-1.43164v-15h1v-2h-5l-1,-1zM7,5h10v15h-10zM9,7v11h2v-11zM13,7v11h2v-11z"></path></g></g></svg>
      </>
  )
}